<template>
    <div class="card housekeeping-card position-relative">
        <div class="bg-blue-light p-1">
            <TitleButton
                :showBtn="false"
                :showAddNew="false"
                title="Housekeeping"
            />
        </div>

        <div class="d-flex flex-wrap gap-1 px-2 mt-2">
            <button
                v-for="tab in tabs"
                :key="tab.value"
                class="btn btn-sm"
                :class="activeTab === tab.value ? 'btn-primary' : 'btn-outline-secondary'"
                @click="onClickTab(tab.value)"
            >
                {{ tab.label }}
            </button>
        </div>

        <div class="px-2 mt-3 mb-4">
            <HousekeepingDirty v-if="activeTab === 'dirty'"/>
            <HousekeepingInspection v-if="activeTab === 'under_inspection'"/>
        </div>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import HousekeepingDirty from '@/components/molecule/company/hotel/hotel-housekeeping/HousekeepingDirty.vue';
import HousekeepingInspection from '@/components/molecule/company/hotel/hotel-housekeeping/HousekeepingInspection.vue';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const $route = useRoute();
const $router = useRouter();

const activeTab = ref('dirty');
const tabs = ref([
    { label: 'Dirty', value: 'dirty' },
    { label: 'Under Inspection', value: 'under_inspection' },
]);

const onClickTab = (value) => {
    if (activeTab.value === value) return;
    activeTab.value = value;
    const routeQuery = Object.assign({}, $route.query, { tab: value });
    delete routeQuery.page;
    $router.replace({ path: $route.path, query: routeQuery });
};

const restoreActiveTab = () => {
    const currentTab = $route.query.tab;
    if (!currentTab) return;
    const matched = tabs.value.find(tab => tab.value === currentTab);
    if (!matched) return;
    activeTab.value = currentTab;
};

onMounted(() => {
    restoreActiveTab();
});
</script>

<style scoped>
.housekeeping-card {
    min-height: 75vh;
    padding-bottom: 4rem;
}
</style>
